



import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component({
  name: 'AddOnBadge',
})
export default class AddOnBadge extends Vue {
  @Getter('global/labels') labels: Record<string, any>
  @Prop({ type: Number, default: 0 }) numOfAddOns: number

  get addOnBadgeLabel() {
    const template = this.labels?.Checkout?.AddonsBadgeLabel
    return template ? template.replace('{0}', this.numOfAddOns) : ''
  }
}
